/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_HOME = 'SET_HOME';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_DEVICE = 'SET_DEVICE';
export const SET_DEVICENOTIFY = 'SET_DEVICENOTIFY';
export const SET_CLIENT = 'SET_CLIENT';
export const SET_LANG = 'SET_LANG';
export const SET_USER = 'SET_USER';
export const SET_PERM = 'SET_PERM';
export const SET_MENU = 'SET_MENU';
export const SET_NOTIFY = 'SET_NOTIFY';
export const SET_BADGE = 'SET_BADGE';
export const SET_AUTHEN = 'SET_AUTHEN';
export const SET_POS = 'SET_POS';

export function clearState(data, device) {
  return {
    type: CLEAR_STATE,
    payload: data,
    device: device,
  };
}

export function setHome(id) {
  return {
    type: SET_HOME,
    payload: id,
  };
}

export function setClient(id) {
  return {
    type: SET_CLIENT,
    payload: id,
  };
}

export function setDevice(id) {
  return {
    type: SET_DEVICE,
    payload: id,
  };
}

export function setToken(id) {
  return {
    type: SET_TOKEN,
    payload: id,
  };
}

export function setLang(id) {
  return {
    type: SET_LANG,
    payload: id,
  };
}

export function setUser(data) {
  return {
    type: SET_USER,
    payload: data,
  };
}

export function setPerm(data) {
  return {
    type: SET_PERM,
    payload: data,
  };
}

export function setMenu(data) {
  return {
    type: SET_MENU,
    payload: data,
  };
}

export function setNotify(data) {
  return {
    type: SET_NOTIFY,
    payload: data,
  };
}

export function setDeviceNotify(data) {
  return {
    type: SET_DEVICENOTIFY,
    payload: data,
  };
}

export function setBadge(data) {
  return {
    type: SET_BADGE,
    payload: data,
  };
}

export function setAuthen(data) {
  return {
    type: SET_AUTHEN,
    payload: data,
  };
}

export function setPos(data) {
  return {
    type: SET_POS,
    payload: data,
  };
}
